import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import requestClient from '../../utils/requestClient';
import Image from '../../components/Elements/Image';
import Video from '../../components/Elements/Video';
import DownloadButton from '../../components/Elements/DownloadButton';

const Article = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [article, setArticle] = useState([]);

  useEffect(() => {
    async function getArticle() {
      const response = await requestClient().get(`/api/v2/employer/resources/${id}/`)
      setArticle(response.data.data);
    }
    getArticle();
  }, []);

  return (article && article.accessible_to_employees ?
    <main>
      <article className='bg-white'>
        <div className='container py-8 lg:py-12'>
          <div className='flex items-center justify-between mb-8'>
            <nav className='hidden lg:block'>
                <ul className='text-sm uppercase flex items-center'>
                    <li>
                        <Link to="/resources">Resources</Link>
                        <span className='mx-2'>/</span>
                    </li>
                    <li className='text-purple font-bold'>
                        {article.title}
                    </li>
                </ul>
            </nav>
          </div>
          <Link to={`/resources`} className="flex items-center mb-8 lg:hidden">← RESOURCES</Link>
          <div className='max-w-[768px] mx-auto'>
            <h1 className='mb-8'>{article.title}</h1>
            
            {article.video ? (
                <Video src={article.video} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
              ) : article.image ? (
                <Image src={article.image} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
              ) : null}

            {article.pdf_document && <DownloadButton content={article.pdf_document} />}

            <section>
              {article.additional_information ? (
                <div className="mt-8 prose whitespace-pre-line">
                  <p>{article.additional_information}</p>
                </div>
              ) : null}
            </section>
          </div>
        </div>
      </article>
    </main>
    : null
  );
};

export default Article;
